<template>
  <div class="comparison">
    <section class="comparison-hero">
      <div class="comparison-container text-center">
        <h1 class="comparison-title">{{ t('pages./comparison.hero.title') }}</h1>
        <p class="comparison-subtitle">{{ t('pages./comparison.hero.subtitle') }}</p>
      </div>
    </section>

    <!-- 對照表：窄螢幕由外層容器橫向捲動，不讓整頁被撐開 -->
    <section class="comparison-section">
      <div class="comparison-container">
        <div class="comparison-table-wrap">
          <table class="comparison-table">
            <caption class="visually-hidden">{{ t('pages./comparison.table.caption') }}</caption>
            <thead>
              <tr>
                <th scope="col">{{ t('pages./comparison.table.head-aspect') }}</th>
                <th scope="col">{{ t('pages./comparison.table.head-chat') }}</th>
                <th scope="col">{{ t('pages./comparison.table.head-automation') }}</th>
                <th scope="col" class="is-kikuflow">{{ t('pages./comparison.table.head-kikuflow') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row">
                <th scope="row">{{ t(`pages./comparison.table.${row}-label`) }}</th>
                <td>{{ t(`pages./comparison.table.${row}-chat`) }}</td>
                <td>{{ t(`pages./comparison.table.${row}-automation`) }}</td>
                <td class="is-kikuflow">{{ t(`pages./comparison.table.${row}-kikuflow`) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section class="comparison-section">
      <div class="comparison-container comparison-prose">
        <div v-for="block in blocks" :key="block" class="comparison-block">
          <h2 class="comparison-block-title">{{ t(`pages./comparison.${block}.title`) }}</h2>
          <p class="comparison-block-body">{{ t(`pages./comparison.${block}.body`) }}</p>
        </div>
      </div>
    </section>

    <section class="comparison-section comparison-section-alt">
      <div class="comparison-container text-center">
        <h2 class="comparison-cta-title">{{ t('pages./comparison.cta.title') }}</h2>
        <a :href="signupPath" class="comparison-btn">{{ t('pages./comparison.cta.button') }}</a>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const rows = ['r1', 'r2', 'r3', 'r4']
// note 放最後：先講三類工具，再說明它們並不互斥
const blocks = ['chat', 'automation', 'kikuflow', 'note']

const signupPath = computed(() => {
  const lang = route.params.lang as string | undefined
  return lang ? `/${lang}/signup` : '/signup'
})
</script>

<style scoped>
.comparison-container {
  max-width: 60rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.comparison-hero {
  padding: 5rem 0 3rem;
}

.comparison-title {
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.comparison-subtitle {
  font-size: 1.05rem;
  line-height: 1.9;
  color: #6c757d;
  max-width: 42rem;
  margin: 0 auto;
}

.comparison-section {
  padding: 3rem 0;
}

.comparison-section-alt {
  background: #f8f9fa;
}

.comparison-table-wrap {
  overflow-x: auto;
}

.comparison-table {
  width: 100%;
  min-width: 44rem;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.comparison-table th,
.comparison-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e9ecef;
  text-align: left;
  vertical-align: top;
}

.comparison-table thead th {
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}

.comparison-table tbody th {
  font-weight: 600;
  color: #212529;
  width: 12rem;
}

.comparison-table td {
  color: #495057;
}

.comparison-table .is-kikuflow {
  background: #f8f9fa;
  color: #212529;
}

.comparison-prose {
  max-width: 46rem;
}

.comparison-block {
  margin-bottom: 2.5rem;
}

.comparison-block:last-child {
  margin-bottom: 0;
}

.comparison-block-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.comparison-block-body {
  font-size: 1.02rem;
  line-height: 1.9;
  color: #495057;
  margin: 0;
}

.comparison-cta-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
}

.comparison-btn {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: #212529;
  color: #fff;
  border-radius: 0.375rem;
  text-decoration: none;
  font-weight: 500;
}

.comparison-btn:hover {
  background: #000;
  color: #fff;
}
</style>
